import axios from 'axios'

interface IpApiResponse {
  country_code: string
  ip: string
  city?: string
  region?: string
  [key: string]: any
}

/**
 * Gets the user's country code based on their IP address
 * @returns Promise that resolves to the country code (e.g., 'US', 'FR')
 */
export const localize = (): Promise<string | undefined> => {
  return axios
    .get<IpApiResponse>('https://ipapi.co/json/')
    .then(response => {
      const data = response.data
      return data.country_code
    })
    .catch(error => {
      /* console.error(error) */
      return undefined
    })
}
